
/**
 * Eine Collection, welche die Anzahl der Elemente zählt, also eine Map Key => Anzahl.
 * Anzahl ist reel (erlaubt negative und Nachkomma). Typischer Anwendungszweck ist das Zählen
 * von Produkten in einer Szene.
 *
 * Aufgrund der momentanen Unmöglichkeit, Map abzuleiten (Babel), ist Bag keine ES6-Klasse,
 * deshalb wird Bag auch nicht mit new erzeugt!
 *
 * Bag leitet von Map ab und hat daher alle Methoden von Map: forEach, map, filter...
 *
 * @example
 * const bag = Bag(['a','a','c','b'])
 * bag.get('a') => 2
 * bag.get('c') => 1
 * bag.inc('c',1.5);
 * bag.get('c') => 2,5
 * bag.toArray() => ['a','a','c','c','b']
 */
const Bag = (iterable) => {

    // currently with babelfish Map cannot be extended
    const bag = new Map();

    /**
     * Addiert zum Key den Wert byCount
     */
    bag.inc = (key, byCount = 1) => {
        let c = bag.get(key) || 0;
        c += byCount;
        bag.set(key, c);
    }

    /**
     * Subtrahiert zum Key den Wert byCount
     */
    bag.dec = (key, byCount = 1) => {
        bag.inc(key, -byCount);
    }

    /**
     * interner Helfer
     */
    const forAll = (method) => (iterable) => {
        if (!iterable) {
            return;
        }
        if (iterable instanceof Set || _.isArray(iterable)) {
            iterable.forEach((key)=>bag[method](key));
        } else if (iterable instanceof Map) {
            // Vorsicht! _.forEach kann Map nicht iterieren!
            iterable.forEach((number, key)=>bag[method](key, number));
        } else if (iterable instanceof Object) {
            _.forEach(iterable, (number, key)=>bag[method](key, number));
        }
    }

    /**
     * Erwartet einen Bag als Parameter und addiert alle Werte Key-Weise
     */
    bag.incAll = forAll('inc');

    /**
     * Erwartet einen Bag als Parameter und subtrahiert alle Werte Key-Weise
     */
    bag.decAll = forAll('dec');

    /**
     * Löscht alle Einträge, für welche filter(anzahl,key) true ergibt
     */
    bag.deleteWhere = (filter) => {
        new Set(bag.keys()).forEach(key=> {
            if (filter(bag.get(key),key)) {
                bag.delete(key)
            }
        });
    }

    /**
     * multipliziert zu allen Einträgen eine Zahl
     */
    bag.multiply = (value) => bag.forEach((number, key)=>bag.set(key,number*value));

    /**
     * addiert zu allen Einträgen eine Zahl
     */
    bag.addition= (value) => bag.forEach((number, key)=>bag.set(key,number+value));

    /**
     * cloned das Bag
     */
    bag.clone = () => Bag(bag);

    /**
     * wandelt das Bag in eine Liste der Keys um, wobei jeder Key sooft vorkommt, wie seine aufgerundete Anzahl ist.
     * Negative Zahlen werden als 0 gewertet, entsprechend erscheinen die Keys nicht.
     */
    bag.toArray = () => {
        const list = [];
        bag.forEach((number, key)=>{
            for (let i=0; i<number; i++) {
                list.push(key);
            }
        });
        return list;
    }

    bag.incAll(iterable);

    bag.toString = ()=>JSON.stringify(bag);

    return bag;
}


export default Bag;



